import { Box, Checkbox, FormControl, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'
import { Time } from '../../Helper/Time'
import TimeRangeInput from '../atoms/TimeRangeInput'

export interface LessonUnrservableInputFormProps {
    lurvable_date?: Date | null
    startTime: Time
    endTime: Time
    enableTimeRange: boolean
    timeRangeFrom: Time
    timeRangeTo: Time
    timeRangeUnit: number
    onChange: (lurvable_date: Date | null | undefined, start: Time, end: Time) => void
    onChangeEnableTimeRange: (enableTimeRange: boolean) => void
    lurvableId?: number
}

const LessonunReservableInputForm: React.FC<LessonUnrservableInputFormProps> = ({
    lurvable_date,
    startTime,
    endTime,
    enableTimeRange,
    timeRangeFrom,
    timeRangeTo,
    timeRangeUnit,
    onChange,
    onChangeEnableTimeRange,
    lurvableId,
}) => {
    return (
        <Box>
            <Grid
                container
                alignItems="center"
                spacing={5}
            >
                {lurvableId &&
                    <Grid item>
                        <Typography>[{lurvableId}]</Typography>
                    </Grid>
                }
                <Grid item>
                    <FormControl sx={{
                        width: 200
                    }}>
                        <DatePicker
                            label="予約不可日"
                            onChange={date => {
                                if (date) {
                                    onChange(date, startTime, endTime)
                                }
                            }}
                            value={lurvable_date ? lurvable_date : null}
                            renderInput={params => <TextField {...params} size="small" />}
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            defaultCalendarMonth={null}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControlLabel
                        label="時間範囲を指定"
                        control={
                            <Checkbox
                                checked={enableTimeRange}
                                onChange={e => {
                                    onChangeEnableTimeRange(e.target.checked)
                                }}
                            />
                        }
                    />
                </Grid>
                <Grid item xs>
                    <TimeRangeInput
                        onChange={(start: Time | null, end: Time | null) => {
                            if (start && end) {
                                onChange(lurvable_date, start, end)
                            }
                        }}
                        startTime={startTime ? startTime : null}
                        endTime={endTime ? endTime : null}
                        disabled={!enableTimeRange}
                        from={timeRangeFrom}
                        to={timeRangeTo}
                        unit={timeRangeUnit}
                        disableClear
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default LessonunReservableInputForm